<form (ngSubmit)="submit()" class="flex flex-col gap-4">
    <!-- Improvement procedure values -->
    <div class="flex flex-col gap-2">
        <label class="form-label">{{
            'translate_improvement_procedures_description_in_arabic' | translate
        }}</label>
        <textarea
            dir="rtl"
            class="w-full"
            [disabled]="
                type === 'data-entry-response'
                    ? !canEditImprovementProcedure || readOnly
                    : isApproved ||
                      (!allowDynamicAnalysisEdit &&
                          !canEditImprovementProcedure)
            "
            [(ngModel)]="improvementProcedures.valueAr"
            [ngModelOptions]="{ standalone: true }"
        ></textarea>
    </div>

    <div class="flex flex-col gap-2">
        <label class="form-label">{{
            'translate_improvement_procedures_description_in_english'
                | translate
        }}</label>
        <textarea
            dir="ltr"
            class="w-full"
            [disabled]="
                type === 'data-entry-response'
                    ? !canEditImprovementProcedure || readOnly
                    : isApproved ||
                      (!allowDynamicAnalysisEdit &&
                          !canEditImprovementProcedure)
            "
            [(ngModel)]="improvementProcedures.valueEn"
            [ngModelOptions]="{ standalone: true }"
        ></textarea>
    </div>

    <!-- Improvement procedure date -->
    <div class="flex flex-col gap-2">
        <p class="mb-1">
            {{ 'translate_expected_completion_date' | translate }}
        </p>
        <input
            appFlatpickr
            type="date"
            [config]="{
                clickOpens:
                    type === 'data-entry-response'
                        ? canEditImprovementProcedure && !readOnly
                        : !isApproved &&
                          (allowDynamicAnalysisEdit ||
                              canEditImprovementProcedure),
            }"
            [attr.disabled]="
                (
                    type === 'data-entry-response'
                        ? !canEditImprovementProcedure || readOnly
                        : isApproved ||
                          (!allowDynamicAnalysisEdit &&
                              !canEditImprovementProcedure)
                )
                    ? 'disabled'
                    : null
            "
            class="w-full"
            [(ngModel)]="improvementProcedures.expectedCompletionDate"
            [ngModelOptions]="{ standalone: true }"
        />
    </div>

    <!-- Improvement procedure percentages -->
    <div class="flex flex-col gap-3">
        <p class="text-center text-sm font-medium text-slate-600">
            {{ 'translate_completion_percentage' | translate }}
        </p>
        <app-range-slider
            [min]="0"
            [max]="100"
            [step]="1"
            [showValue]="true"
            [showMinMax]="true"
            [disabled]="
                type === 'data-entry-response'
                    ? !canEditImprovementProcedure || readOnly
                    : isApproved ||
                      (!allowDynamicAnalysisEdit &&
                          !canEditImprovementProcedure)
            "
            [ngModel]="improvementProcedures.percentage ?? 0"
            (ngModelChange)="improvementProcedures.percentage = $event"
            [ngModelOptions]="{ standalone: true }"
        ></app-range-slider>
    </div>

    @if (
        type === 'data-entry-response'
            ? canEditImprovementProcedure && !readOnly
            : !isApproved &&
              (allowDynamicAnalysisEdit || canEditImprovementProcedure)
    ) {
        <div class="text-center">
            <ng-container [ngTemplateOutlet]="buttonTemplate"></ng-container>
        </div>
    }
</form>

<ng-template #buttonTemplate>
    <button type="submit" class="btn btn-lg btn-primary">
        <i class="fa-light fa-save me-2"></i>
        <span>{{ 'translate_save' | translate }}</span>
    </button>
</ng-template>
